module.exports = __webpack_public_path__ + "img/1.f0af0d51.jpg";